import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// MARK://dhk8/ui/components/Toast
// Toast provider minimalista context-based. Port de sc-restaurant Toast.tsx.
import { createContext, useCallback, useContext, useState } from 'react';
import { createPortal } from 'react-dom';
const ToastContext = createContext(null);
export function ToastProvider({ children }) {
    const [toasts, setToasts] = useState([]);
    const toast = useCallback((message, tone = 'default') => {
        const id = Math.random().toString(36).slice(2);
        setToasts((prev) => [...prev, { id, message, tone }]);
        setTimeout(() => {
            setToasts((prev) => prev.filter((t) => t.id !== id));
        }, 3500);
    }, []);
    return (_jsxs(ToastContext.Provider, { value: { toast }, children: [children, typeof document !== 'undefined' &&
                createPortal(_jsx("div", { className: "dhk8-toast-container", children: toasts.map((t) => (_jsx("div", { className: [
                            'dhk8-toast',
                            t.tone === 'error' ? 'dhk8-toast--error' : '',
                            t.tone === 'success' ? 'dhk8-toast--success' : '',
                        ].filter(Boolean).join(' '), role: "status", "aria-live": "polite", children: t.message }, t.id))) }), document.body)] }));
}
export function useToast() {
    const ctx = useContext(ToastContext);
    if (!ctx)
        throw new Error('useToast debe usarse dentro de <ToastProvider>');
    return ctx;
}
//# sourceMappingURL=Toast.js.map